import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from 'react'

interface FieldProps {
  label: string
  hint?: string
  error?: string
  children: ReactNode
}

export function Field({ label, hint, error, children }: FieldProps) {
  return (
    <label className="block">
      <div className="mb-1 text-caption font-medium text-text-tertiary">{label}</div>
      {children}
      {(hint || error) && (
        <div className={`mt-1 text-caption ${error ? 'text-pack-safety' : 'text-text-quiet'}`}>{error ?? hint}</div>
      )}
    </label>
  )
}

interface TextProps extends InputHTMLAttributes<HTMLInputElement> {}

export function TextInput(props: TextProps) {
  return (
    <input
      {...props}
      className={`block w-full rounded-r-sm bg-bg-elevated px-3 py-3 text-body text-text-primary placeholder:text-text-quiet border border-divider-subtle focus:border-white/25 focus:outline-none transition-colors ${props.className ?? ''}`}
    />
  )
}

interface AreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export function TextArea(props: AreaProps) {
  return (
    <textarea
      {...props}
      className={`block w-full rounded-r-sm bg-bg-elevated px-3 py-3 text-body text-text-primary placeholder:text-text-quiet border border-divider-subtle focus:border-white/25 focus:outline-none resize-none transition-colors ${props.className ?? ''}`}
    />
  )
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode
}

export function Select({ children, ...rest }: SelectProps) {
  return (
    <select
      {...rest}
      className={`block w-full rounded-r-sm bg-bg-elevated px-3 py-3 text-body text-text-primary border border-divider-subtle focus:border-white/25 focus:outline-none transition-colors appearance-none ${rest.className ?? ''}`}
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' stroke='%23C4CBC6' stroke-width='1.6'><path d='M4 6l4 4 4-4'/></svg>\")",
        backgroundPosition: 'right 12px center',
        backgroundRepeat: 'no-repeat',
        paddingRight: 40,
      }}
    >
      {children}
    </select>
  )
}
